import React, { FunctionComponent } from 'react'
import Grid, { GridProps } from '@material-ui/core/Grid'
import FormControl from '@material-ui/core/FormControl'
import InputLabel from '@material-ui/core/InputLabel'
import Select from '@material-ui/core/Select'
import MenuItem from '@material-ui/core/MenuItem'
import { typeaheadPrefixLength, useSelectTypeahead } from 'hooks/useSelectTypeahead'

const highlight = (label: string, query: string) => {
  const length = typeaheadPrefixLength(label, query)

  if (length < 1) {
    return label
  }

  // MenuItem is display:flex, so without the wrapper the remainder becomes its own
  // anonymous flex item and drops its leading space: "SA Skolas" renders as "SASkolas".
  return (
    <span>
      <u>{label.slice(0, length)}</u>
      {label.slice(length)}
    </span>
  )
}

export type Props = {
  id: string
  name: string
  label: string
  value: any
  required?: boolean
  size?: 'small' | 'medium'
  error?: string
  disabled: boolean
  options?: string[]
  optionsCustom?: { label: string | JSX.Element; id: any }[]
  typeahead?: boolean
  onChange: (e: any) => void
  GridProps?: GridProps
}
export type Functions = {}
export type AllProps = Props & Functions

export const SelectField: FunctionComponent<AllProps> = ({
  GridProps,
  size,
  label,
  value,
  required,
  id,
  name,
  disabled,
  error,
  onChange,
  options,
  optionsCustom,
  typeahead,
}) => {
  const items = optionsCustom || (options || []).map((option, i) => ({ label: option, id: i }))
  const { query, selectProps } = useSelectTypeahead(
    Boolean(typeahead),
    items.map(item => (typeof item.label === 'string' ? item.label : '')),
  )

  return (
    <Grid item {...GridProps}>
      <FormControl fullWidth variant="outlined" required={required} size={size} disabled={disabled}>
        <InputLabel>{label}</InputLabel>
        <Select
          value={value}
          label={label}
          error={Boolean(error)}
          onChange={onChange}
          {...selectProps}
        >
          {items.map((item, i) => (
            <MenuItem key={i} value={item.id}>
              {typeof item.label === 'string' ? highlight(item.label, query) : item.label}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
    </Grid>
  )
}

export default SelectField
